"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ResultColumnType_1 = __importDefault(require("./interfaces/ResultColumnType"));
var ResultColumnFactory = /** @class */ (function () {
    function ResultColumnFactory() {
    }
    ResultColumnFactory.getLabel = function (resultColumn) {
        switch (resultColumn.type) {
            case ResultColumnType_1.default.COLUMN:
                var col = resultColumn;
                return col.table + "_" + col.name;
            case ResultColumnType_1.default.FUNC:
                var func = resultColumn;
                return func.column.table + "_" + func.column.name;
            case ResultColumnType_1.default.FORMULA:
                throw new Error(" formula is not supported");
        }
    };
    ResultColumnFactory.getColumnOnlyLabel = function (resultColumn) {
        switch (resultColumn.type) {
            case ResultColumnType_1.default.COLUMN:
                var col = resultColumn;
                return col.name;
            case ResultColumnType_1.default.FUNC:
                var func = resultColumn;
                return func.name + " " + func.column.name;
            case ResultColumnType_1.default.FORMULA:
                throw new Error(" formula is not supported");
        }
    };
    ResultColumnFactory.getColumn = function (resultColumn) {
        switch (resultColumn.type) {
            case ResultColumnType_1.default.COLUMN:
                var col = resultColumn;
                return col;
            case ResultColumnType_1.default.FUNC:
                var func = resultColumn;
                return func.column;
            case ResultColumnType_1.default.FORMULA:
                throw new Error(" formula is not supported");
        }
    };
    ResultColumnFactory.getColumnName = function (resultColumn) {
        switch (resultColumn.type) {
            case ResultColumnType_1.default.COLUMN:
                var col = resultColumn;
                return col.name;
            case ResultColumnType_1.default.FUNC:
                var func = resultColumn;
                return func.column.name;
            case ResultColumnType_1.default.FORMULA:
                throw new Error(" formula is not supported");
        }
    };
    ResultColumnFactory.getTable = function (resultColumn) {
        switch (resultColumn.type) {
            case ResultColumnType_1.default.COLUMN:
                var col = resultColumn;
                return col.table;
            case ResultColumnType_1.default.FUNC:
                var func = resultColumn;
                return func.column.table;
            case ResultColumnType_1.default.FORMULA:
                throw new Error(" formula is not supported");
        }
    };
    ResultColumnFactory.getColumnNames = function (resultColumns) { return resultColumns.map(function (resultColumn) {
        return ResultColumnFactory.getColumnName(resultColumn);
    }); };
    return ResultColumnFactory;
}());
exports.default = ResultColumnFactory;
//# sourceMappingURL=ResultColumnFactory.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/abstract_query/ResultColumnFactory.js
// module id = 229
// module chunks = 8